import {Component, Input} from '@angular/core';
import {BaseClass} from 'src/app/shared/classes/base';
import {ToastController} from '@ionic/angular';
import {TranslationService} from 'src/app/shared/services/translation.service';
import {FinalReport} from 'src/app/final-report/_interfaces/final-report.interface';
import {ProcessConfig, QuestionConfig} from 'src/app/shared/interfaces/process-config.interface';
import {ProcessTypeEnum} from 'src/app/shared/interfaces/process.interface';

@Component({
    selector: 'app-coaching-report',
    templateUrl: './coaching-report.component.html',
    styleUrls: ['./coaching-report.component.scss']
})
export class CoachingReportComponent extends BaseClass {

    @Input() report: FinalReport;
    @Input() readonly showMoreLess: Boolean;
    public titleKey: string = '2+2 Coaching';
    public questionsConfig: QuestionConfig[];
    public evaluation = {};

    private processConfig: ProcessConfig;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService
    ) {
        super(_toastController, _translationService);
    }

    public ngOnInit(): void {
        this.processConfig = this.report.processConfigs.find(c => c.type === ProcessTypeEnum.TwoPlusTwoCoaching);
        this.titleKey = this.processConfig.globalizationConfig[this.getSelectedLanguage()].title;
        this.questionsConfig = this.processConfig ? this.processConfig.questions : [];
    }


}
